// src/config.js
const AppConfig = {
    title: "failed",
    paragraph: "Loading corrupted due to security problem",
    img: "https://i.postimg.cc/zBvTx8kx/IMG-6877.jpg",
    url: "url",
    id: "05060726"
};

export default AppConfig;